import React, { useState } from "react";
import { Button, SearchBar, Typography } from "@kitbird/core";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import JobTitleTable from "./components/JobTitleTable";
import ModalFormJobTitle from "./components/ModalFormJobTitle";
import useJobTitle from "./hooks/useJobTitle";
import PageLoading from "../../../components/Loading/PageLoading";

const Jobtitle = () => {
  const useCustomHook = useJobTitle();

  const {
    modalFormJobtitle,
    setModalFormJobTitle,
    setSearch,
    isLoading,
    valueToEdit,
    setValueToEdit,
    onSubmit,
  } = useCustomHook;

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Master job title</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium" >
              Daftar job title
            </Typography>
          </TitleContent>
          <ActionSection>
            <SearchBar onInputSearch={setSearch} hasReset placeholder="Cari jabatan" />
            <Button
              leftIcon={<PlusIcon />}
              onClick={() => {
                setModalFormJobTitle(true);
                setValueToEdit(undefined);
              }}
            >
              Tambah data
            </Button>
          </ActionSection>
          <StickyTable>
            <JobTitleTable
              showModal={() => setModalFormJobTitle(true)}
              setEditValue={setValueToEdit}
              useCustomHook={useCustomHook}
            />
          </StickyTable>
        </CardContent>
      </PageCard>
      <ModalFormJobTitle
        value={valueToEdit}
        onSubmit={(value) => onSubmit(value)}
        isOpen={modalFormJobtitle}
        setClose={setModalFormJobTitle}
      />
    </PageWrapper>
    {isLoading && (
      <PageLoading />
    )}
  </>);
};

export default Jobtitle;
